// extracted by mini-css-extract-plugin
export default {"changerBlock":"ChangerBlock_changerBlock__iRr+S","exchangeFund":"ChangerBlock_exchangeFund__M72q+","title":"ChangerBlock_title__Tcc+Y","fund":"ChangerBlock_fund__GES8T"};